import { Component, Input, effect } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { LoaderTypes } from '../../../constants/LoaderTypes';
import { SignalsService } from '../../../services/signals.service';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [MatProgressBarModule],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss'
})
export class LoaderComponent {
  @Input() loaderType: LoaderTypes = LoaderTypes.GLOBAL;

  loaderTypes = LoaderTypes;
  localSpinnerloading: boolean;

  constructor(private signalService: SignalsService) {
    effect(() => {
      this.localSpinnerloading = this.signalService.loading();
    });
  }
}
